import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS
} from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'doughnutchart',
  label: 'Doughnut Chart',
  icon: 'DocumentTextIcon',
  description: 'A doughnut chart',
  properties: [
    {
      label: 'Percentage',
      name: 'percent',
      editor: 'number',
      readonly: false,
      description: 'The percentage fill of the doughnut chart',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Text',
      name: 'text',
      editor: 'textbox',
      readonly: false,
      description: 'The text to display underneath the chart',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    }
  ]
};

export default fields;
